import { createContext, useContext, useLayoutEffect, type ReactNode } from 'react'

type SetChromeHidden = (hidden: boolean) => void

const LearnerChromeContext = createContext<SetChromeHidden>(() => {})

export function LearnerChromeProvider({
  children,
  setHidden,
}: {
  children: ReactNode
  setHidden: SetChromeHidden
}) {
  return (
    <LearnerChromeContext.Provider value={setHidden}>
      {children}
    </LearnerChromeContext.Provider>
  )
}

export function useLearnerChromeVisibility(hidden: boolean) {
  const setHidden = useContext(LearnerChromeContext)

  useLayoutEffect(() => {
    setHidden(hidden)
    return () => setHidden(false)
  }, [hidden, setHidden])
}
